import { Injectable } from '@angular/core';
import { UserInfoDto } from '@valg-shared/services/auth-service/user-info-dto';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly filterPrefix = 'valg-localstorage-';

  isValidKey(key: string | undefined | null): boolean {
    return key !== undefined && key !== null && key !== '';
  }

  saveLastSelectedOption(optionsKey: string, districtId: string): void {
    if (!optionsKey || !districtId) {
      return;
    }

    localStorage.setItem(optionsKey, districtId);
  }

  generateLastSelectedOptionKey(userInfo: UserInfoDto, electionId: string, type: string): string | undefined {
    if (!userInfo?.userId || !type || !electionId) {
      return undefined;
    }

    return `${this.filterPrefix}${userInfo.userId}-${electionId}-${type}-last-selected-option`;
  }

  getLastSelectedOptionFromKey<T extends string>(key: string | undefined | null): T | undefined {
    if (!this.isValidKey(key)) return undefined;

    const lastSelectedOption = localStorage.getItem(key!);
    if (!lastSelectedOption || lastSelectedOption === null) {
      return undefined;
    }

    return lastSelectedOption as T;
  }
}
